import {EditPermissions} from "../../../../../../../shared/models";
import {UntypedFormArray, UntypedFormControl, UntypedFormGroup} from "@angular/forms";
import {getEditTypes} from "../../../delegatorUtils";
import {required} from "../../../../../../../shared/utils";
import {newStepValue} from "../../../../../services/flowBuilder/utils/constants";

export interface ResponseHeaders {
    key: string,
    value: string
}

export interface AsyncApiNodeForm {
    name: string,
    description:  string,
    responseHeaders:  ResponseHeaders[],
    responseHttpStatus: string,
    responseBody:  string,
    next:  string,
}

export class AsyncApiNode {

    private integration: any = {};

    constructor(name: string, description: string) {
        this.integration = {
            name, description,
            "integrationType": "endNode",
            "endNode": {
                "endNodeType": "async_api"
            }
        };
    }

    public static toForm(stepData: { [index: string]: any }, editPermissions: EditPermissions): UntypedFormGroup {
        const {editFlows} = getEditTypes(editPermissions);

        const integration = stepData?.integration;
        const outputVars = integration?.endNode.outputVars
        const responseHeaders = outputVars?.responseHeaders ? outputVars?.responseHeaders : {};

        return new UntypedFormGroup({
            name: new UntypedFormControl({
                value: integration?.name ? integration.name : '',
                disabled: !editFlows
            }, required('Name')),
            description: new UntypedFormControl({
                value: integration?.description ? integration.description : '',
                disabled: !editFlows
            }, required('Description')),
            responseHeaders: this.responseHeadersToFrom(responseHeaders, editFlows),
            responseHttpStatus: new UntypedFormControl({
                value: outputVars?.responseHttpStatus ? outputVars.responseHttpStatus : '',
                disabled: !editFlows
            }, required('Status code')),
            responseBody: new UntypedFormControl({
                value: outputVars?.responseBody ? outputVars.responseBody : '',
                disabled: !editFlows
            }),
            next: new UntypedFormControl({
                value: outputVars?.next ? outputVars.next : newStepValue,
                disabled: !editFlows
            }),
        });
    }

    private static responseHeadersToFrom(headers: {}, editFlows: boolean): UntypedFormArray {
        const headerFormArray = new UntypedFormArray([])
        for (const headerKey in headers) {
            headerFormArray.push(
                new UntypedFormGroup({
                        key: new UntypedFormControl({
                            value: headerKey,
                            disabled: !editFlows
                        }),
                        value: new UntypedFormControl({
                            value: headers[headerKey],
                            disabled: !editFlows
                        }),
                    }
                )
            )
        }

        return headerFormArray
    }

    public setOutputVars(responseHttpStatus: string, responseBody: string, responseHeaders: ResponseHeaders[], next: string) {
        this.integration.endNode.outputVars = {
            responseHttpStatus,
            responseBody,
            next,
            responseHeaders: this.responseHeadersToSave(responseHeaders)
        }
    }

    private responseHeadersToSave(responseHeaders: ResponseHeaders[]): {} {
        const responseHeaderToSave = {};
        for (const header of responseHeaders) {
            responseHeaderToSave[header.key] = header.value
        }

        return responseHeaderToSave
    }

    get getStepData(): {} {
        return {
            integration: this.integration,
            'type': 'integration',
            metadata: {
                nodeVersion: '1.0.0'
            }
        };
    }

    public static getHeaderTemplate(): UntypedFormGroup {
        return new UntypedFormGroup({
                key: new UntypedFormControl("", required('Key')),
                value: new UntypedFormControl("", required('Value')),
            }
        )
    }
}


// # stepX:
// #  integration:
// #    integrationType: "endNode"
// #    name: "Callback ApiEndNode"
// #    description: "Callback ApiEndNode"
// #    endNode:
// #      endNodeType: "async_api"
// #      outputVars:
// #        responseHttpStatus: "202"
// #        responseHeaders:
// #           bloo: "haha"
// #        responseBody: " "
// #        next: stepY
// #  type: "integration"
// #  metadata:
